export const VALID_PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

export const isValidPhone = (phone: string): boolean => {
  return VALID_PHONE_REGEX.test(phone);
};

export const formatPhoneNumber = (phone: string, { pickEnd = true } = {}) => {
  // Remove any existing formatting
  let cleaned = (phone || '')
    .replace(/^\+1/, '') // Remove leading +1 only if it's at the start
    .replace(/[^0-9]/g, ''); // Remove all non-digit characters

  if (pickEnd) {
    cleaned = cleaned.slice(-10);
  }

  // Otherwise format as before
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

type ParsePhoneNumberOptions = {
  countryCode?: string;
  includeCountryCode?: boolean;
};

export const parsePhoneNumber = (
  phone: string,
  { countryCode = '1', includeCountryCode = true }: ParsePhoneNumberOptions = {}
): string => {
  if (!phone) return '';

  const digits = phone.replace(/[^0-9]/g, '').slice(-10);

  if (digits.length !== 10) return digits;

  return includeCountryCode ? `+${countryCode}${digits}` : digits;
};
